import React from 'react'
import PropTypes from 'prop-types'
import { reduxForm, SubmissionError } from 'redux-form'
import { PrivacyMessage } from './PrivacyMessage'
import FormErrors from './FormErrors'
import { SubmitButton } from 'LiveBoard/components/shared/SubmitButton'
import { validateForm } from './validator'
import PublicEventsDispatcher from 'common/services/PublicEventsDispatcher'
import withCta from 'LiveBoard/components/shared/CallToAction/types/forms/withCta'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import map from 'lodash/map'
import merge from 'lodash/merge'
import './style.css.scss'

const publicEventsDispatcher = PublicEventsDispatcher()

class FormWrapper extends React.Component {

  validateFormErrors = (checkboxesConfig, values) => {
    const errors = !!this.props.customValidation
      ? this.props.customValidation(values, checkboxesConfig)
      : validateForm({
        values,
        form: this.props.form,
        privacyMessageCheckboxConfig: checkboxesConfig
      })

    if(!isEmpty(errors)) {
      throw new SubmissionError(errors)
    }
  }

  getCheckBoxConfig = () => {
    const checkboxesConfig = this.props.showPrivacyMsg ?
      get(this.props.config.privacy_message, 'checkbox_area.checkboxes', []) :
      []
    return checkboxesConfig
  }

  handleSubmitClick = (values) => {
    const checkboxesConfig = this.getCheckBoxConfig()
    this.validateFormErrors(checkboxesConfig, values)
    let formData = merge(values, this.props.getCtaParams())

    if(this.props.showPrivacyMsg) {
      formData.privacy = {
        privacy_text: this.props.config.privacy_message.message.html,
        checkboxes: checkboxesConfig ? map(checkboxesConfig, (checkbox) => {
          if(!!checkbox.label) {
            return {
              label: checkbox.label,
              name: checkbox.name,
              checked: values[checkbox.name] || false,
            }
          }
        }): [],
        privacy_additional_text: get(
          this.props.config.privacy_message, 'checkbox_area.text_area.html', ''
        )
      }
    }

    publicEventsDispatcher.dispatch(
      publicEventsDispatcher.EventTypes.ctaSubmit, {
        ctaType: 'form',
        ctaData: formData
      }
    )

    return this.props.onSubmit(formData)
  }

  render() {
    const formId = get(this.props.config.metadata, 'form_id', '')

    return (
      <section className="form-wrapper-box">
        { this.props.title && <h1>{this.props.title}</h1> }
        <form className={`cta-form CustomForm_${formId}`} onSubmit={this.props.handleSubmit(this.handleSubmitClick)}>
          { React.cloneElement(this.props.children, {errors: this.props.errors}) }
          { this.props.showPrivacyMsg &&
            <PrivacyMessage
              config={this.props.config.privacy_message}
              errors={this.props.errors}
              themeColorHex={this.props.themeColorHex}/>
          }
          <FormErrors errors={this.props.errors} />
          <SubmitButton
            onClick={this.props.handleSubmit(this.handleSubmitClick)}
            themeColorHex={this.props.themeColorHex}
            submitLabel={this.props.submitBtnLabel || undefined}
            submitting={this.props.submitting}
            submitSucceeded={this.props.submitSucceeded}
            successMessage={this.props.successMessage || undefined} />
        </form>
      </section>
    )
  }
}

FormWrapper.propTypes = {
  config: PropTypes.object.isRequired,
  area: PropTypes.string.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  showPrivacyMsg: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  submitSucceeded: PropTypes.bool.isRequired,
  customValidation: PropTypes.func,
  submitBtnLabel: PropTypes.string,
  errors: PropTypes.object,
  itemId: PropTypes.number,
  form: PropTypes.string.isRequired,
  initialValues: PropTypes.object,
  title: PropTypes.string,
  successMessage: PropTypes.string
}

export default reduxForm({})(withCta(FormWrapper))
